import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';

import { LoginResponse, RegistrationLoginResponse } from '../models/auth.model';
import { GetUserProfileResponse, UserRole } from '../models/user.model';

@Injectable({
  providedIn: 'root',
})
export class Auth {
  private readonly http = inject(HttpClient);

  login(email: string, password: string) {
    return this.http.post<LoginResponse>('/api/login', {
      email,
      password,
    });
  }

  registrationLogin(email: string, temporaryPassword: string) {
    return this.http.post<RegistrationLoginResponse>('/api/auth/registration-login', {
      email,
      temporaryPassword,
    });
  }

  completeFirstLogin(firstLoginToken: string, name: string, surname: string, newPassword: string) {
    return this.http.post<LoginResponse>('/api/auth/complete-first-login', {
      firstLoginToken,
      name,
      surname,
      newPassword,
    });
  }

  getToken(): string | null {
    return localStorage.getItem('token');
  }

  saveToken(token: string): void {
    localStorage.setItem('token', token);
  }

  removeToken(): void {
    localStorage.removeItem('token');
  }

  isAuthenticated(): boolean {
    return Boolean(this.getToken());
  }

  hasValidSession(): Observable<boolean> {
    if (!this.isAuthenticated()) {
      return of(false);
    }

    return this.http.get<GetUserProfileResponse>('/api/user/profile').pipe(
      map(() => true),
      catchError(() => {
        this.removeToken();
        return of(false);
      }),
    );
  }

  hasRoleSession(role: UserRole): Observable<boolean> {
    if (!this.isAuthenticated()) {
      return of(false);
    }

    return this.http.get<GetUserProfileResponse>('/api/user/profile').pipe(
      map((res) => res.user.role === role),
      catchError(() => {
        this.removeToken();
        return of(false);
      }),
    );
  }
}
